export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9260.59836568.jpg";